import { ApplicationInsights } from '@microsoft/applicationinsights-web'

const connectionString = import.meta.env.VITE_APPLICATIONINSIGHTS_CONNECTION_STRING as string | undefined

export const appInsights = new ApplicationInsights({
  config: {
    connectionString,
    enableAutoRouteTracking: true,
    autoTrackPageVisitTime: true,
    enableCorsCorrelation: true,
    enableUnhandledPromiseRejectionTracking: true,
    enableAjaxErrorStatusText: true,
    enableAjaxPerfTracking: true,
  },
})

if (connectionString) {
  appInsights.loadAppInsights()
  appInsights.addTelemetryInitializer((envelope) => {
    envelope.tags = envelope.tags ?? []
    envelope.tags['ai.cloud.role'] = 'vvsi-web-app-service'
  })
  appInsights.trackPageView()
}

export function trackEvent(name: string, properties?: Record<string, string>): void {
  if (connectionString) {
    appInsights.trackEvent({ name }, properties)
    appInsights.flush()
  }
}

export function trackException(error: Error, properties?: Record<string, string>): void {
  if (connectionString) {
    appInsights.trackException({ exception: error }, properties)
  }
}

export function trackMetric(name: string, value: number): void {
  if (connectionString) {
    appInsights.trackMetric({ name, average: value })
  }
}

export function trackPageView(name?: string): void {
  if (connectionString) {
    appInsights.trackPageView({ name })
  }
}

export function setAuthenticatedUser(userId: string): void {
  if (connectionString) {
    appInsights.setAuthenticatedUserContext(userId, undefined, true)
  }
}

export function clearAuthenticatedUser(): void {
  if (connectionString) {
    appInsights.clearAuthenticatedUserContext()
  }
}
